export default "__VITE_ASSET__zBJUOlSU__"